// import React from "react"

import {
  isAndroid,
  uniqueId,
  getDataFromLocalStorage,
  setDataInLocalStorage,
  clearAllDataFromLocalStorage,
} from "./utils"
import {
  TYPES,
  CHATBOT_TYPE,
  LANGUAGES,
  LOCAL_STORAGE,
  // CHAT_STATE
} from "./constants"
import * as defaultMessages from "./defaultMessages"
import * as chatbotText from "./chatbotText"
import * as assets from "../assets"

// import { store } from "../../index"
// import actionTypes from "../../data/redux/actiontypes"

// import MdChatBubbleOutline from "react-icons/lib/md/chat-bubble-outline"
// import FaWhatsapp from "react-icons/lib/fa/whatsapp"
// import MdOutlineMailOutline from "react-icons/lib/md/mail-outline"

//=================== INITIAL BRAND SPECIFIC LOGIC ====================

//=================== INITIAL BRAND SPECIFIC END HERE ===================

export const translator = {
  enable: false,
  query_param_key: "lang",
  text: {
    [LANGUAGES.ENGLISH]: chatbotText.english,
    [LANGUAGES.ARABIC]: chatbotText.arabic,
  },
  assets: {
    [LANGUAGES.ENGLISH]: assets.english,
    [LANGUAGES.ARABIC]: assets.arabic,
  },
  getLanguage() {
    let lang = LANGUAGES.ENGLISH
    if (this.enable) {
      //=========== BRAND SPECIFIC LOGIC ==========
      const query_params = new URLSearchParams(window.location.search)
      if (query_params.has(this.query_param_key)) {
        const key = query_params.get(this.query_param_key)
        if (this.text[key]) lang = key
      }
      //=================== END ===================
    }
    return lang
  },
}

export const chatbot_setting = {
  chatbot_type: CHATBOT_TYPE.DEFAULT, // default, fullScreen, adster,
  trigger_type: TYPES.DEFAULT, // default, lottie. floatingMenu
  floating_menu_type: TYPES.DEFAULT, //default, circular
  floating_menu_options: [
    // {
    //   icon: <MdChatBubbleOutline size={30} />,
    //   title: "Chat with us",
    //   type: "chatbot",
    // },
    // {
    //   icon: <FaWhatsapp size={30} />,
    //   title: "Whatsapp Us",
    //   action: () => {
    //     console.log("Whatsapp Us")
    //   },
    // },
    // {
    //   icon: <MdOutlineMailOutline size={30} />,
    //   title: "Email Us",
    //   action: () => {
    //     console.log("Email Us")
    //   },
    // },
  ],
  ga4: false, // to enable Google ANalytics 4. please ensure your ga4MeasurementId before enabling it
  amplitude_tracking: false, // must set amplitudeTrackingId in url before enabling this
  track_bot_triggered: false, // to track number of user open our chatbot
  show_trigger_close: true,
  image_type_brand_name: {
    enable: false,
    redirect: false,
    link: "https://oriserve.com/",
  },
  security: {
    enable: false,
    code: "123456",
  },
  message_footer: {
    enable: true,
    voting: true,
    read_status: true,
    timestamp: true,
  },
  emit_unread_msg_seen: true,
  auto_close_feedback_form: 2 * 1000 * 60, //in milisecond only
  feedback_form_rating_type: TYPES.DEFAULT, // default or star
  show_feedback_rating_linebar: true,
  feedback_rating_pivot: 3,
  hide_buttons_in_msg_bubble: false, // to hide the buttons inside the message bubbles
  default_btn_display_count: 7,
  auto_close_chatbot_on_refresh: false, //in milliseconds only
  automate_connection_time: 3600, //in seceond only
  automate_reset_chat_time: 3600 * 24 * 4, //in second only
  auto_open_chatbot: {
    enable: false,
    query_param_key: "chatbotopen",
  },
  notification_sound_allowed: false,
  send_brand_data_on_user_first_msg: false,
  default_initial_delay_for_default_msg: 1000,
  auto_emit_message: {
    enable: false,
    get_default_messages: false,
    default_text_message: "hi",
    query_param_key: "oribotmessage",
    send_brand_data: false,
    update_last_emit: false,
    initial_delay_for_default_msg: 5000,
  },
  timestamp_tag: true,
  speech_recognition: true,
  minimize_bot: true,
  header_end_chat: true,
  header_avatar_shape: "circle", // circle || square
  header_avatar_size: "large",
  header_avatar_on_click: {
    enable: false,
    link: "https://oriserve.com/",
  },
  header_tag_allowed_height: 420,
  powered_by: {
    visibility: false, // to enable powered by tag
    target_url: "http://oriserve.com/"
  },
  menu: {
    visible: true,
    children: {
      privacy_policy: false,
      terms_and_conditions: false,
      feedback: true,
      clear_chat: false,
      end_chat: false,
      download_chatlog: false,
      email_chatlog: false,
    },
  },
  upload_file: false,
  downloadChatlogsDuration: 24, // in hour
  downloadChatlogsFileType: [
    { label: "PDF", value: "pdf" },
    { label: "Text", value: "txt" },
  ],
  max_upload_file_size: 500000,
  new_window_positon_and_size: {
    height: window.innerHeight / 2,
    width: window.innerWidth / 2,
    left: window.innerWidth / 8,
    top: window.innerHeight / 8,
  },
  chat_interface: {
    show_sender_avatar: false,
    show_receiver_avatar: true,
    avatar_shape: "circle", // circle || square
    avatar_size: "default",
    show_feedback_avatar: true,
    show_feedback_emoji: false,
    quick_reply_bg_transparent: true,
    scroll_upto_first_response_only: true,
    carousel_msg_display_type: TYPES.ACTUAL, // default, fixed, actual
    text_with_media_img_popup_disable: false,
    carousel_img_popup_disable: false,
    type_writer: {
      enable: false,
      deleting_speed: 150,
      typing_speed: 30,
    },
  },
  notification_bot: {
    visibility: true, // to enable notification popup (set value false in android and ios )
    stack_view: true, // to show to stack view of notification bot
    bottom_height_lg: 110,
    bottom_height_sm: 100,
  },
  auto_hide_notification_bubbles: {
    enable: false,
    delay: 10000, // in ms
  },
}

export const chatbot_default_messages = {
  enable: false,
  query_param_key: "msg",
  delay: 1000, // in ms
  getDefaultMessages() {
    if (chatbot_setting.auto_emit_message.get_default_messages) return []
    let defaultMsgs = defaultMessages.getDefaultMessagesByKey()
    if (isAndroid())
      defaultMsgs = defaultMessages.getDefaultMessagesByKey("android")
    if (this.enable) {
      //=========== BRAND SPECIFIC LOGIC ==========
      const query_params = new URLSearchParams(window.location.search)
      if (query_params.has(this.query_param_key)) {
        const key = query_params.get(this.query_param_key)
        const msgs = defaultMessages.getDefaultMessagesByKey(key)
        defaultMsgs = msgs
      }
      //=================== END ===================
    }
    return defaultMsgs
  },
}

export const chatbot_psids = {
  default_primary_value: "p",
  default_secondary_value: "vi-neo",
  primary_key_enable: false,
  primary_key: "pKey",
  secondary_key_enable: false,
  secondary_key: "sKey",
  psid_ttl: 24 * 3600 * 1000, // psid time to live = 1 days
  brandLogicToGetPrimaryValue() {
    let primary_value = this.default_primary_value
    if (this.primary_key_enable) {
      //=========== BRAND SPECIFIC LOGIC TO FINDOUT PSID VALUE==========
      const query_params = new URLSearchParams(window.location.search)
      if (query_params.has(this.primary_key)) {
        primary_value = query_params.get(this.primary_key)
      }
      //=================== END ===================
    }
    return primary_value
  },
  brandLogicToGetSecondaryValue() {
    let secondary_value = this.default_secondary_value
    if (this.secondary_key_enable) {
      //=========== BRAND SPECIFIC LOGIC TO FINDOUT SECONDARY KEY VALUE==========
      const query_params = new URLSearchParams(window.location.search)
      if (query_params.has(this.secondary_key)) {
        secondary_value = query_params.get(this.secondary_key)
      }
      //=================== END ===================
    }
    return secondary_value
  },
  getPsid() {
    const psidMap = getDataFromLocalStorage(LOCAL_STORAGE.PSID_MAP, {})
    let isSomethingExpired = false
    Object.keys(psidMap).forEach((sKey) => {
      if (
        psidMap[sKey].psid &&
        psidMap[sKey].expiry &&
        new Date().getTime() > psidMap[sKey].expiry
      ) {
        clearAllDataFromLocalStorage(psidMap[sKey].psid)
        psidMap[sKey].expiry = new Date().getTime() + this.psid_ttl
        if (!isSomethingExpired) isSomethingExpired = true
      }
    })
    if (isSomethingExpired)
      setDataInLocalStorage(LOCAL_STORAGE.PSID_MAP, psidMap)
    const key = `${this.brandLogicToGetPrimaryValue()}_${this.brandLogicToGetSecondaryValue()}`
    if (psidMap[key] && psidMap[key].psid) return psidMap[key].psid
    psidMap[key] = {
      psid: uniqueId(),
      expiry: new Date().getTime() + this.psid_ttl,
    }
    setDataInLocalStorage(LOCAL_STORAGE.PSID_MAP, psidMap)
    return psidMap[key].psid
  },
  setPsid(psid) {
    const psidMap = getDataFromLocalStorage(LOCAL_STORAGE.PSID_MAP, {})
    const key = `${this.brandLogicToGetPrimaryValue()}_${this.brandLogicToGetSecondaryValue()}`
    psidMap[key] = { psid, expiry: new Date().getTime() + this.psid_ttl }
    setDataInLocalStorage(LOCAL_STORAGE.PSID_MAP, psidMap)
  },
}

export const brand_features = {
  enable_trigger_brand_logic: false,
  enable_onload_brand_logic: true,
  getBrandData() {
    const data = {}
    //=========== BRAND SPECIFIC LOGIC ==========

    //=================== END ===================
    return data
  },
  doBrandLogicOnEndChat() {
    if (chatbot_setting.chatbot_type === CHATBOT_TYPE.FULL_SCREEN) {
    }
  },
  allowedImageTypeUpload(filename) {
    let bool = false
    //=========== BRAND SPECIFIC LOGIC ==========
    bool = /\.(gif|jpg?g|jpeg|svg|tiff|png)$/i.test(filename)
    //=================== END ===================
    return bool
  },
  showTriggerByBrandLogic() {
    let show_trigger = true
    //=========== BRAND SPECIFIC LOGIC TO FINDOUT TRIGGER  VALUE==========

    //=================== END ===================
    return show_trigger
  },
  allowChatbotByBrandLogic() {
    let isAllowed = true
    //=========== BRAND SPECIFIC LOGIC ON LOAD CHATBOT APP ==========
    //=================== END ===================
    return isAllowed
  },
  doBrandLogicOnChatStateChange(data, dispatch) {
    if (dispatch) {
      //=========== BRAND SPECIFIC LOGIC ON CHAT STATE CHANGE ==========
      // const upload_file = data.chatState === CHAT_STATE.AGENT_HANDLING ? true : chatbot_setting.upload_file
      // setDataInLocalStorage(LOCAL_STORAGE.UPLOAD_FILE + data.psid, upload_file)
      // dispatch(updateChatsState({ upload_file }))
      //=================== END ===================
    }
  },
  doBrandLogicOnLoadChatbotApp() {

    //=========== BRAND SPECIFIC LOGIC ON LOAD CHATBOT APP ==========
    setTimeout(() => {
      const unseen_messages = getDataFromLocalStorage(LOCAL_STORAGE.UNSEEN_MESSAGES + chatbot_psids.getPsid(),[])
      const unseen_notification = unseen_messages.filter(message => message.type === 'notification' && message.subtype === 'webPopupNotification')
      if (window.bot_popup && unseen_notification.length === 0) {
        const case_data = { caseName: "pageLoadNudge", caseId: "default" }
        window.bot_popup(case_data, {})
      }
    }, 21000)
    //=================== END ===================
  },
  doSomethingBeforeLoadChatbotThenContinue(continueExecution) {
    //=========== BRAND SPECIFIC LOGIC BEFORE LOAD CHATBOT APP ==========
    // if (navigator.userAgent.match(/Android/i)) {
    //   let win = window.open("https://businessmessages.google.com/widget/agent/85f31306-e47c-4994-a21f-e7f092f62cf9?i=CiQ4NWYzMTMwNi1lNDdjLTQ5OTQtYTIxZi1lN2YwOTJmNjJjZjkSDAjTn8WKBhCA19XUARoCdjEqRwpFaHR0cHM6Ly93d3cubXl2aS5pbi9uZXctY29ubmVjdGlvbi9idXktcG9zdHBhaWQtc2ltLWNvbm5lY3Rpb24tb25saW5l&ctx=", "_blank");
    //   win.focus();
    //   return
    // }
    continueExecution()
    //=================== END ===================
  },
  doBrandLogicOnClickOut() {
    //=========== BRAND SPECIFIC LOGIC ON CLICK BUTTON AND HEADER ==========
    //=================== END ===================
  },
  doBrandLogicOnUserFirstEmit() {
    //=========== BRAND SPECIFIC LOGIC ON USER FIRST EMIT ==========
    //=================== END ===================
  },
  doBrandLogicOnBannerClick() {
    //=========== BRAND SPECIFIC LOGIC ON BANNER CLICK ==========
    //=================== END ===================
  },
  getChatBotDirection() {
    let direction = "ltr" //! it must be either rtl or ltr
    //=========== BRAND SPECIFIC LOGIC TO GET THE DIRECTION OF THE CHATBOT ==========

    //=================== END ===================
    return direction
  },
  doBrandLogicOnBotTrackingSuccess(res) {
    //=========== BRAND SPECIFIC LOGIC TO GET THE DIRECTION OF THE CHATBOT ==========
    console.log("doBrandLogicOnBotTrackingSuccess", res)
    //=================== END ===================
  },
}

export const adster_settings = {
  banner: true, // to add banner image code
  banner_initial_transtion_delay: 5000, // in ms
  banner_query_params_key: "segment",
  banner_images: {
    default: {
      default:
        "https://dummyimage.com/420x200/000/fff.png&text=default-default",
      ad1: "https://dummyimage.com/420x200/000/fff.png&text=ad1-default",
      ad2: "https://dummyimage.com/420x200/000/fff.png&text=ad2-default",
    },
    "0-0.25": {
      default: "https://dummyimage.com/150x600/000/fff.png&text=default-0-0.25",
      ad1: "https://dummyimage.com/150x600/000/fff.png&text=ad1-0-0.25",
      ad2: "https://dummyimage.com/150x625/000/fff.png&text=ad2-0-0.25",
    },
    "0.26-0.5": {
      default:
        "https://dummyimage.com/320x650/000/fff.png&text=default-0.26-0.5",
      ad1: "https://dummyimage.com/320x650/000/fff.png&text=ad1-0.26-0.5",
      ad2: "https://dummyimage.com/300x600/000/fff.png&text=ad2-0.26-0.5",
    },
    "0.51-0.75": {
      default:
        "https://dummyimage.com/320x480/000/fff.png&text=default-0.51-0.75",
      ad1: "https://dummyimage.com/320x568/000/fff.png&text=ad1-0.51-0.75",
      ad2: "https://dummyimage.com/320x568/000/fff.png&text=ad2-0.51-0.75",
    },
    "0.76-1": {
      default: "https://dummyimage.com/380x500/000/fff.png&text=default-0.76-1",
      ad1: "https://dummyimage.com/380x500/000/fff.png&text=ad1-0.76-1",
      ad2: "https://dummyimage.com/380x500/000/fff.png&text=ad2-0.76-1",
    },
    "1.1-1.25": {
      default:
        "https://dummyimage.com/336x280/383438/fff.png&text=default-1.1-1.25",
      ad1: "https://dummyimage.com/336x280/383438/fff.png&text=ad1-1.1-1.25",
      ad2: "https://dummyimage.com/336x280/383438/fff.png&text=ad2-1.1-1.25",
    },
    "1.26-1.5": {
      default:
        "https://dummyimage.com/300x250/383438/fff.png&text=default-1.26-1.5",
      ad1: "https://dummyimage.com/1024x768/383438/fff.png&text=ad1-1.26-1.5",
      ad2: "https://dummyimage.com/1024x768/383438/fff.png&text=ad2-1.26-1.5",
    },
    "1.51-1.75": {
      default:
        "https://dummyimage.com/480x300/383438/fff.png&text=default-1.51-1.75",
      ad1: "https://dummyimage.com/480x300/383438/fff.png&text=ad1-1.51-1.75",
      ad2: "https://dummyimage.com/480x300/383438/fff.png&text=ad2-1.51-1.75",
    },
    "1.76-2": {
      default: "https://dummyimage.com/568x320/000/fff.png&text=default-1.75-2",
      ad1: "https://dummyimage.com/568x320/000/fff.png&text=ad1-1.75-2",
      ad2: "https://dummyimage.com/568x320/000/fff.png&text=ad1-1.75-2",
    },
  },
  getBannerByRange(range, key) {
    if (this.banner_images[range][key]) return this.banner_images[range][key]
    return this.banner_images[range].default
  },
  getBannerByAspectRatio(aspectRatio, key) {
    if (aspectRatio <= 0.25) return this.getBannerByRange("0-0.25", key)
    else if (aspectRatio <= 0.5) return this.getBannerByRange("0.26-0.5", key)
    else if (aspectRatio <= 0.75) return this.getBannerByRange("0.51-0.75", key)
    else if (aspectRatio <= 1) return this.getBannerByRange("0.76-1", key)
    else if (aspectRatio <= 1.25) return this.getBannerByRange("1.1-1.25", key)
    else if (aspectRatio <= 1.5) return this.getBannerByRange("1.26-1.5", key)
    else if (aspectRatio <= 1.75) return this.getBannerByRange("1.51-1.75", key)
    else if (aspectRatio <= 2) return this.getBannerByRange("1.76-2", key)
    else return this.getBannerByRange("default", key)
  },
}
